import { createApp } from 'vue'
import AppComponent from './App.vue'
import router, { createHttpGuard } from './router/index'
import 'element-plus/dist/index.css'
import './styles/index.less'
import 'core-js/stable'
import 'regenerator-runtime/runtime'
import { setupStore } from '@/store'
import { setupI18n } from './i18n'
import { customEvent } from './utils/utils'
import { handleInitVConsole } from '@/utils/handleVConsole'
import { setUpElement } from '@/plugin/element-plus'

import loadingDirective from '@/components/Loading/loading'
import customEventDirective from '@/components/CustomEventData/customEvent'

handleInitVConsole()

createHttpGuard(router)

// 自动引入所有的 SVG 图标
const requireAll = (requireContext: any) => requireContext.keys().map(requireContext)
// @ts-ignore
const req = require.context('./assets/icons/svg', false, /\.svg$/)
requireAll(req)

const app = createApp(AppComponent)

app.config.globalProperties.$customEvent = customEvent
app.directive('cusLoading', loadingDirective)
app.directive('customEvent', customEventDirective)
app.use(router)

setupStore(app)
setupI18n(app)
setUpElement(app)
app.mount('#app')
